import { ICommand } from 'core-ts-types';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APTermsQuery } from '../../queries/ap_terms_query';

class PlannerAddTermMenu {
  constructor(
    private addTermCommand: ICommand,
    private phxAxTitleAnnouncerDelegate: any,
    private ngAPTermsQuery: APTermsQuery,
    private ngAPNotificationDelegate: INotificationDelegate
  ) {}

  addTermMenu(term: APTerm) {
    if (term) {
      this.addTermCommand(term.id, term.name).then(() => {
        this.phxAxTitleAnnouncerDelegate.announceChange(`${term.name} term added`);
        this.ngAPNotificationDelegate.success(`${term.name} term added successfully.`);
      });
    }
  }
}

angular.module('capability-ng-academic-planner').component('plannerAddTermMenu', {
  controller: PlannerAddTermMenu,
  templateUrl: 'capability-ng-academic-planner/src/plan/components/planner_add_term_menu/planner_add_term_menu.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_add_term_menu/planner_add_term_menu.ts